import React from 'react';
import './UploadSpinner.scss';

const UploadSpinner = () => {
  return <div className="loader"></div>
}

export default UploadSpinner;